import {BasePanelWidget} from "../../BasePanelWidget";
import {DataStore} from "../../DataStore";
import {Triggers} from "mu-js-utils/lib/Triggers";
import {TNames} from "../../TNames";

export class UiEditNote extends BasePanelWidget
{
    // @ts-ignore
    public uid: number|{journalActivityId:number}|{accountId:number,day:Date};

    beforeIndex() {
        this.muAppendContent(`
            <div class="c-form-pair">
                <label class="c-form-pair__label" mu-for="note">Poznámka</label>
                <div class="c-form-pair__control-container">
                    <textarea mu="note#note"></textarea>
                </div>
            </div>
            <div class="btn-box btn-box--expand">
                <span mu="bSave" class="btn--primary">Uložit</span>
                <span mu="bCancel" class="btn--cancel">Storno</span>
            </div>
        `);
    }

    async bSave_click() {
        await DataStore.get().saveNote(this.uid, this.ui.note.value);
        Triggers.dispatch(TNames.JournalActivityChanged);
    }

    bCancel_click() {
        this.closeMe();
    }

}